import { motion } from 'framer-motion';

interface Props {
  title: string;
  description?: string;
}

export function SectionTitle({ title, description }: Props) {
  const words = title.split(' ');
  const lastWord = words.pop();
  const firstPart = words.join(' ');
  return (
    <div className='flex flex-col items-center'>
      <motion.h2
        className='text-center text-5xl font-semibold max-w-2xl'
        initial={{ y: 80, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ type: 'spring', stiffness: 320, damping: 70, mass: 1 }}
      >
        {firstPart}{' '}
        <motion.span
          className='bg-gradient-to-t from-brand-border to-white rounded-xl px-4 py-2 bg-left inline-block bg-no-repeat'
          initial={{ backgroundSize: '0% 100%' }}
          whileInView={{ backgroundSize: '100% 100%' }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.7, ease: 'easeInOut' }}
        >
          {lastWord}
        </motion.span>
      </motion.h2>
      <motion.p
        className='text-center max-w-lg mt-6 text-lg'
        initial={{ y: 120, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ type: 'spring', stiffness: 240, damping: 70, mass: 1 }}
      >
        {description}
      </motion.p>
    </div>
  );
}
